export default __webpack_public_path__ + "static/media/services-banner.f030326e.svg";